// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let DateFns = require("date-fns");
let DateFnsTz = require("../../../reason/common/DateFns/DateFnsTz.bs.js");
let Types__Time = require("../../../reason/common/types/Types__Time.bs.js");
let CalendarDate = require("../../../reason/common/types/CalendarDate.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function requiredString(value) {
  let value$1 = Stdlib_Option.map(value, prim => prim.trim());
  if (value$1 !== undefined && value$1 !== "") {
    return "Valid";
  } else {
    return {
      NAME: "Error",
      VAL: "is required"
    };
  }
}

function requiredPositiveInt(value) {
  if (value !== undefined) {
    if (value > 0) {
      return "Valid";
    } else {
      return {
        NAME: "Error",
        VAL: "must be greater than 0"
      };
    }
  } else {
    return {
      NAME: "Error",
      VAL: "is required"
    };
  }
}

function requiredNonNegativeInt(value) {
  if (value !== undefined) {
    if (value >= 0) {
      return "Valid";
    } else {
      return {
        NAME: "Error",
        VAL: "must be 0 or greater"
      };
    }
  } else {
    return {
      NAME: "Error",
      VAL: "is required"
    };
  }
}

function optionalNonNegativeInt(value) {
  if (value !== undefined) {
    if (value >= 0) {
      return "Valid";
    } else {
      return {
        NAME: "Error",
        VAL: "must be 0 or greater"
      };
    }
  }
}

function requiredOption(value) {
  if (value !== undefined) {
    return "Valid";
  } else {
    return {
      NAME: "Error",
      VAL: "is required"
    };
  }
}

function requiredValidatedString(validate, invalidError, value) {
  if (value === undefined) {
    return {
      NAME: "Error",
      VAL: "is required"
    };
  }
  if (value.trim() === "") {
    return {
      NAME: "Error",
      VAL: "is required"
    };
  }
  let error = validate(value);
  if (error.TAG === "Ok") {
    return "Valid";
  } else {
    return {
      NAME: "Error",
      VAL: invalidError(error._0)
    };
  }
}

function optionalValidatedString(validate, invalidError, value) {
  if (value === undefined) {
    return;
  }
  if (value.trim() === "") {
    return;
  }
  let error = validate(value);
  if (error.TAG === "Ok") {
    return "Valid";
  } else {
    return {
      NAME: "Error",
      VAL: invalidError(error._0)
    };
  }
}

function requiredStringWithMaxLength(maxLength, tooLongError, value) {
  if (value !== undefined && value.trim() !== "") {
    if (value.length > maxLength) {
      return {
        NAME: "Error",
        VAL: tooLongError(maxLength)
      };
    } else {
      return "Valid";
    }
  } else {
    return {
      NAME: "Error",
      VAL: "is required"
    };
  }
}

function endTimeAfterStartTime(endTime, startTime) {
  if (endTime === undefined) {
    return {
      NAME: "Error",
      VAL: "is required"
    };
  }
  if (startTime === undefined) {
    return;
  }
  let match = Types__Time.decode(endTime);
  let match$1 = Types__Time.decode(startTime);
  if (match.TAG === "Ok" && match$1.TAG === "Ok") {
    if (Types__Time.cmp(match._0, match$1._0) >= 0) {
      return "Valid";
    } else {
      return {
        NAME: "Error",
        VAL: "must be after start time"
      };
    }
  } else {
    return {
      NAME: "Error",
      VAL: "time malformed"
    };
  }
}

function calendarDateOnOrAfterToday(date, timeZone) {
  if (date === undefined) {
    return {
      NAME: "Error",
      VAL: "is required"
    };
  }
  let date$1 = Primitive_option.valFromOption(date);
  let today = CalendarDate.toLocalDate(CalendarDate.today(DateFnsTz.Timezone.make(timeZone)));
  if (DateFns.isSameDay(CalendarDate.toLocalDate(date$1), today) || DateFns.isAfter(CalendarDate.toLocalDate(date$1), today)) {
    return "Valid";
  } else {
    return {
      NAME: "Error",
      VAL: "must be after today"
    };
  }
}

function allValid(validations) {
  if (validations.every(validation => validation !== undefined ? typeof validation !== "object" : true)) {
    return "Valid";
  } else {
    return "Invalid";
  }
}

function allSubStepsValid(validations) {
  if (validations.every(validation => validation !== "Invalid")) {
    return "Valid";
  } else {
    return "Invalid";
  }
}

function optResultToDummyStringResult(optResult) {
  return Stdlib_Option.map(optResult, m => {
    if (typeof m === "object") {
      return {
        NAME: "Error",
        VAL: ""
      };
    } else {
      return "Valid";
    }
  });
}

let requiredTime = requiredString;

let requiredDate = requiredOption;

exports.requiredString = requiredString;
exports.requiredPositiveInt = requiredPositiveInt;
exports.requiredNonNegativeInt = requiredNonNegativeInt;
exports.optionalNonNegativeInt = optionalNonNegativeInt;
exports.requiredOption = requiredOption;
exports.requiredValidatedString = requiredValidatedString;
exports.optionalValidatedString = optionalValidatedString;
exports.requiredStringWithMaxLength = requiredStringWithMaxLength;
exports.requiredTime = requiredTime;
exports.requiredDate = requiredDate;
exports.endTimeAfterStartTime = endTimeAfterStartTime;
exports.calendarDateOnOrAfterToday = calendarDateOnOrAfterToday;
exports.allValid = allValid;
exports.allSubStepsValid = allSubStepsValid;
exports.optResultToDummyStringResult = optResultToDummyStringResult;
/* date-fns Not a pure module */
